var map = {
	"./Ondoklassniki.svg": "ad3d",
	"./Telegram.svg": "55da",
	"./VK.svg": "85f9",
	"./Viber.svg": "0a4a",
	"./YouTube.svg": "2ebb",
	"./facebook.svg": "905e",
	"./instagram.svg": "4149"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7050";